import { Table } from "@/features/Table";
import { type K2StaticDatum, porfolios_columns } from "./columns";
import {
  type FilterK2StaticDatumsSchema,
  FilterK2StaticDatums,
} from "./filter";

const client = "k2";
const table_name = "k2_static_data";

export const K2StaticDatumsTable = () => {
  return (
    <Table<K2StaticDatum, FilterK2StaticDatumsSchema>
      label="Actifs"
      client={client}
      table_name={table_name}
      columns={porfolios_columns}
      filter={<FilterK2StaticDatums />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
};
